'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
            'svg',
            {
                height: props.height,
                width: props.width,
                version: '1.1',
                viewBox: '0 0 24 24',
                xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement(
                'g',
                { fill: 'none', fillRule: 'evenodd', stroke: 'none', strokeWidth: '1' },
                _react2.default.createElement('path', { d: 'M0 0h24v24H0z' }),
                _react2.default.createElement('path', {
                    d: 'M17 5.96v1.867h-1.667V5.96H8.667v1.867H7V5.96H3.667v3.493h16.667V5.96H17zm0-1.704h3.333c.92 0 1.667.765 1.667 1.704v15.336c0 .94-.747 1.704-1.667 1.704H3.667C2.747 23 2 22.235 2 21.296V5.96c0-.94.747-1.704 1.667-1.704H7V2h1.667v2.256h6.666V2H17v2.256zm-13.333 6.73v10.31h16.667v-10.31H3.667zm3.56 4.81c-.586 0-1.06-.485-1.06-1.084 0-.599.474-1.084 1.06-1.084.586 0 1.06.485 1.06 1.084 0 .599-.474 1.084-1.06 1.084zm3.182 0c-.586 0-1.06-.485-1.06-1.084 0-.599.474-1.084 1.06-1.084.585 0 1.06.485 1.06 1.084 0 .599-.475 1.084-1.06 1.084zm3.182 0c-.585 0-1.06-.485-1.06-1.084 0-.599.475-1.084 1.06-1.084.586 0 1.06.485 1.06 1.084 0 .599-.474 1.084-1.06 1.084zm3.182 0c-.586 0-1.06-.485-1.06-1.084 0-.599.474-1.084 1.06-1.084.586 0 1.06.485 1.06 1.084 0 .599-.474 1.084-1.06 1.084zM7.227 19.05c-.586 0-1.06-.485-1.06-1.084 0-.599.474-1.084 1.06-1.084.586 0 1.06.485 1.06 1.084 0 .599-.474 1.084-1.06 1.084zm3.182 0c-.586 0-1.06-.485-1.06-1.084 0-.599.474-1.084 1.06-1.084.585 0 1.06.485 1.06 1.084 0 .599-.475 1.084-1.06 1.084zm3.182 0c-.585 0-1.06-.485-1.06-1.084 0-.599.475-1.084 1.06-1.084.586 0 1.06.485 1.06 1.084 0 .599-.474 1.084-1.06 1.084z',
                    fill: props.fill
                })
            )
        )
    );
};

Icon.propTypes = {
    fill: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Icon.defaultProps = {
    fill: '#000',
    width: '24px',
    height: '24px'
};

Icon.displayName = 'Calendar';

exports.default = Icon;